import slice from './slice';

const selectReducer = slice.reducer;

export const { setFieldSelect } = slice.actions;
export default selectReducer;
